import React, { useEffect, useState } from 'react'
import { useTheme } from 'styled-components'

import { FaTimes } from 'react-icons/fa'

const Toast = ({
    message,
    type = 'error',
    variant,
    show = false,
    onClose,
    duration = 5000,
    position = 'bottom'
}) => {
    const [isVisible, setIsVisible] = useState(show)
   const theme = useTheme()

    useEffect(() => {
        setIsVisible(show)
    }, [show])

    useEffect(() => {
        if (isVisible && duration > 0) {
            const timer = setTimeout(() => {
                handleClose()
            }, duration)

            return () => clearTimeout(timer)
        }
    }, [isVisible, duration])

    const handleClose = () => {
        setIsVisible(false)
        if (onClose) {
            onClose()
        }
    }

    if (!isVisible || !message) return null

    const isDark = type === 'dark' || variant === 'dark'

    const getToastStyles = () => {
        if (isDark) {
            return 'relative z-50 transition-all duration-300 ease-in-out animate-slide-up'
        }
        const baseStyles =
            'fixed left-1/2 transform -translate-x-1/2 z-50 transition-all duration-300 ease-in-out'
        const positionStyles = position === 'top' ? 'top-4' : 'bottom-4'
        return `${baseStyles} ${positionStyles}`
    }



    const getTypeStyles = () => {
        if (isDark) {
            return {
                backgroundColor: '#121212',
                borderColor: 'rgba(255, 255, 255, 0.15)',
                color: '#FFFFFF'
            }
        }
        switch (type) {
            case 'success':
                return {
                    backgroundColor: theme?.app?.background || '#000',
                    borderColor: theme?.app?.inputBorder || '#333',
                    color: theme?.app?.text || '#fff'
                };

            case 'warning':
                return {
                    backgroundColor: theme?.colors?.Yellow_600 || '#d97706',
                    borderColor: theme?.colors?.Yellow_500 || '#f59e0b',
                    color: theme?.colors?.White || '#fff'
                };

            case 'info':
                return {
                    backgroundColor: theme?.colors?.Blue_600 || '#2563eb',
                    borderColor: theme?.colors?.Blue_500 || '#3b82f6',
                    color: theme?.colors?.White || '#fff'
                };

            case 'error':
            default:
                return {
                    backgroundColor: theme?.colors?.Red_500 || '#ef4444',
                    borderColor: theme?.colors?.Red_500 || '#ef4444',
                    color: theme?.colors?.White || '#fff'
                };
        }
    };

    return (
    <div className={getToastStyles()}>
        <div
            className={isDark ? `
            min-w-80 max-w-md
            rounded-[4px] 
            shadow-2xl 
            border border-white/15
            bg-[#0E0E10]/95
            text-white
            flex items-center justify-between
            px-[16px] py-[10px]
            backdrop-blur-md
        ` : `
            px-6 py-4 
            rounded-lg 
            shadow-lg 
            border-2
            mb-6
            flex items-center justify-between 
            min-w-80 max-w-md
            animate-slide-up
        `}

        style={getTypeStyles()}
        >
            <div className="flex items-center gap-2 min-w-0 flex-1">
                <span className={isDark ? "text-xs md:text-sm font-normal text-white/90 tracking-wide break-words" : "text-sm font-medium break-words"}>
                    {message}
                </span>
            </div>

            <button
                onClick={handleClose}
                className={isDark ? "ml-4 text-gray-400 hover:text-white transition-colors duration-200 shrink-0 p-1 rounded-md hover:bg-white/10" : "ml-4 hover:text-gray-200 transition-colors duration-200 flex-shrink-0"}
                aria-label="Close toast"
                style={isDark ? {} : { color: theme?.app?.text }}
            >
                <FaTimes size={isDark ? 13 : 14} />
            </button>
        </div>
    </div>
)
}

export default Toast